/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CrmLeadCommunicationSentBody from "components/CRMComponents/CRMLeadInformationComponents/CRMLeadCommunicationComponents/CrmLeadCommunicationBody/Sent/CrmLeadCommunicationSentBody";

const CrmLeadCommunicationSent = () => {
  useEffect(() => {
    document.title = "CRM Lead Information | Communication";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <CrmLeadCommunicationSentBody />
    </main>
  );
};

export default CrmLeadCommunicationSent;
